import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M4.688 5.89c0-1.486 1.592-2.428 2.894-1.712l12.021 6.612c1.35.742 1.35 2.68 0 3.423L7.582 20.824c-1.302.716-2.894-.225-2.894-1.71z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }